'use client';

import { useTranslate } from '@tolgee/react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { FaSignInAlt } from 'react-icons/fa';

import { AppAvatarMenu } from '@/features/user-settings/components/AppAvatarMenu';
import { useAuth } from '@/lib/auth-hooks';
import { signOutAndRedirect } from '@/lib/sign-out';

interface HeaderAuthLinksProps {
  isOffline: boolean;
}

export function HeaderAuthLinks({ isOffline }: HeaderAuthLinksProps) {
  const { t } = useTranslate();
  const { isLoaded, isSignedIn } = useAuth();
  const router = useRouter();

  if (isOffline) {
    return (
      <div className="flex items-center gap-2">
        <AppAvatarMenu isOffline />
      </div>
    );
  }

  if (!isLoaded) {
    return null;
  }

  if (isSignedIn) {
    return (
      <div className="flex items-center gap-2">
        <AppAvatarMenu isOffline={isOffline} />
        <button
          onClick={async () => {
            await signOutAndRedirect(router);
          }}
          className="text-xs text-gray-400 hover:text-primary-500">
          {t('component.header-auth.sign-out', 'Sign Out')}
        </button>
      </div>
    );
  }

  return (
    <Link
      href="/sign-in"
      className="group flex h-full items-center gap-2 text-sm text-gray-300 hover:text-primary-500"
      data-testid="auth-link">
      <FaSignInAlt className="text-gray-500 group-hover:text-primary-500" />
      {t('component.header-auth.sign-in', 'Sign In')}
    </Link>
  );
}
